export default __webpack_public_path__ + "../staticImages/benefit-price2.svg";